module.exports = __webpack_public_path__ + "img/c_service.7480924b.svg";